import { render } from "./IndvTerms.vue?vue&type=template&id=a3a3ac72&ts=true"
import script from "./IndvTerms.vue?vue&type=script&lang=ts"
export * from "./IndvTerms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__